import { apiClient } from '../config'

export type SendGridActivityMessage = {
  msgId: string
  fromEmail: string
  toEmail: string
  subject: string
  status: string
  opensCount: number
  clicksCount: number
  lastEventTime: string
}

type SendGridActivityResponse = {
  messages: SendGridActivityMessage[]
}

export const sendgridService = {
  getUserActivity: async (userId: string, limit = 25): Promise<SendGridActivityMessage[]> => {
    const response = await apiClient.get<SendGridActivityResponse>(
      `/admin/sendgrid/activity/user/${userId}`,
      { params: { limit: String(limit) } },
    )
    return response.data.messages
  },
}
